import { Component, Input } from '@angular/core';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';
import { MktTaggingTransformationService } from 'src/app/core/services/mkt-tagging-transformation.service';

@Component({
  selector: 'app-credit-card-conversion-benefits',
  templateUrl: './credit-card-conversion-benefits.component.html',
  styleUrls: ['./credit-card-conversion-benefits.component.scss'],
  standalone: false,
})
export class CreditCardConversionBenefitsComponent {
  @Input() contentBenefits: any;
  public imagePrefix: string;

  constructor(private mktEnvironmentService: MktEnvironmentService,
    private _mktTagging: MktTaggingTransformationService) {
    this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
  }
  initTaggingTransformationConsumer() {
    this._mktTagging.tagMktCompareCards("cards-costco-consumer-card-benefits-guide", {
    });
  }
  initTaggingTransformationBusiness() {
    this._mktTagging.tagMktCompareCards("cards-costco-business-card-benefits-guide", {
    });
  }
  initTaggingTransformationRewards() {
    this._mktTagging.tagMktCompareCards("cards-costco-cash-rewards-program-terms", {
    });
  }
}
